import {
  BackofficeProviders,
  BackofficeApp,
  Tab,
  useSession,
} from '@quickbit/backoffice-core-frontend';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useGetConfig } from 'api/configApi';
import { OrganisationProvider, useOrganisation } from 'contexts';
import { tabsData, tabKyb } from './tabs';

const queryClient = new QueryClient();

const ActualApp = () => {
  const { isPlatform, merchants, needsKyb, selectedMerchant } =
    useOrganisation();
  const session = useSession();
  const { data: config } = useGetConfig(!isPlatform && session.authenticated);

  let actualTabsData: Tab[] = tabsData;
  if (isPlatform) {
    actualTabsData =
      merchants.length === 0
        ? [] // edge case for fresh platforms with no merchants
        : tabsData.filter(({ name }) => !['Branding', 'Wallet'].includes(name));
  } else if (config?.config.layoutMode === 'WALLET') {
    actualTabsData = tabsData.filter(({ name }) => ['Wallet'].includes(name));
    if (needsKyb) {
      actualTabsData.push(tabKyb);
    }
  } else {
    actualTabsData = [...tabsData, ...(needsKyb ? [tabKyb] : [])];
  }

  useEffect(() => {
    if (process.env.REACT_APP_ENVIRONMENT !== 'production') {
      const environment = ' ' + (process.env.REACT_APP_ENVIRONMENT || '');
      document.title = document.title.replaceAll(environment, '');
      document.title += environment;
    }
  }, []);

  return (
    <BackofficeApp
      tabs={[...actualTabsData]}
      merchantName={selectedMerchant.name}
    />
  );
};

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <BackofficeProviders>
        <OrganisationProvider>
          <ActualApp />
        </OrganisationProvider>
      </BackofficeProviders>
    </QueryClientProvider>
  );
};

// export
export default App;
